
const little_guys = [
    {
        title: "Walmartholemew",
        href: 'https://dragcave.net/view/QOw6i',
        src: "https://dragcave.net/image/QOw6i.gif",
        category: 'dragcave'
    },
    {
        title: "Sneetle",
        href: 'https://finaloutpost.net/view/pxy85/',
        src: "https://finaloutpost.net/s/pxy85.png",
        category: 'final outpost'
    },
      {
        title: "Snottle",
        href: 'https://finaloutpost.net/view/exTEX/',
        src: "https://finaloutpost.net/s/exTEX.png",
        category: 'final outpost'
    },
    {
        title: "Yarp",
        href: 'https://finaloutpost.net/view/Z1JfN/',
        src: "https://finaloutpost.net/s/Z1JfN.png",
        category: 'final outpost'
    },
    {
        title: "New Type of Dog",
        href: 'https://dragcave.net/view/tfLFs',
        src: "https://dragcave.net/image/tfLFs.gif",
        category: 'dragcave'
    },
    {
        title: "Loathesome Dung-eater",
        href: 'https://dragcave.net/view/rQFMy',
        src: "https://dragcave.net/image/rQFMy.gif",
        category: 'dragcave'
    },
    {
        title: "Smartpanel 2",
        href: 'https://dragcave.net/view/VsrUz',
        src: "https://dragcave.net/image/VsrUz.gif",
        category: 'dragcave'
    },
    {
        title: "Gortholax the Destroyer",
        href: 'https://dragcave.net/view/9O9fC',
        src: "https://dragcave.net/image/9O9fC.gif",
        category: 'dragcave'
    },
]

export default little_guys;